import SchedulingErrors from "../Component/SchedulingErrors";
import { connect } from "react-redux";

import {
  getSchedulingErrorsList
} from "../../../../Action";

const mapStateToProps = (state) => {
  let {
    SchedulingErrorsList
  } = state;
  return {
    SchedulingErrorsList
  };
};
const actionCreators = {
  getSchedulingErrorsList
};
export default connect(mapStateToProps, actionCreators)(SchedulingErrors);
